<template>
  <div class="viewPointList ah">
    <div class="searchBox">
      <el-input
        v-model.trim="searchText"
        placeholder="请输入"
        clearable
        prefix-icon="el-icon-search"
        class="searchInput"
        :style="{ width: shared||isTemplate ? '100%' : undefined }"
      ></el-input>
      <el-tooltip
        content="创建视点"
        placement="top"
        effect="light"
        v-if="viewType === 1 && !isTemplate && !shared"
      >
        <div class="add" @click="createViewPointDebounce" :disabled="permissionLevel <= PermissionLevel.LOOKER">
          <img src="~@/assets/images/camera.png" />
        </div>
      </el-tooltip>
      <el-tooltip
        content="创建动画"
        placement="top"
        effect="light"
        v-if="viewType === 2 && !isTemplate && !shared"
      >
        <div class="add" @click="createAnimationDebounce" :disabled="permissionLevel <= PermissionLevel.LOOKER">
          <img src="~@/assets/images/animation.png" />
        </div>
      </el-tooltip>
    </div>
    <div class="point-list" v-if="pointList && pointList.length > 0">
      <div
        v-for="(item, i) in filtedPoints"
        :key="i"
        class="point-item"
        :class="i === selectedPoint ? 'active' : ''"
        @touchstart.prevent="onSelectPoint(item, i)"
        @click="onSelectPoint(item, i)"
      >
        <el-image
          :src="
            viewType === 1
              ? item.view.coverUrl
              : item.coverUrl
              ? item.coverUrl
              : require('@/assets/images/logo2.png')
          "
          :fit="viewType === 2 && !item.coverUrl ? 'none' : 'cover'"
        >
          <div slot="placeholder" class="image-slot">
            <img src="~@/assets/images/logo2.png" />
          </div>
        </el-image>
        <div class="bottom-btns" :shared="(shared||isTemplate) && viewType === 1" v-if="!!item.id">
          <el-tooltip
            content="播放"
            placement="top"
            effect="light"
            :open-delay="1000"
            :enterable="false"
            v-if="viewType === 2"
          >
            <Icon name="icon-suspend" @click.stop="playAnimation(item)"></Icon>
          </el-tooltip>
          <!-- <el-tooltip content="暂停" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-play1" @click.stop="removeItem(item)"></Icon>
          </el-tooltip> -->
          <el-tooltip
            content="删除"
            placement="top"
            effect="light"
            :open-delay="1000"
            :enterable="false"
            v-if="!isTemplate && !shared"
          >
            <Icon name="icon-ashbin" @click.stop="onRemoveItem(item)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
          </el-tooltip>
        </div>
        <div class="top-tag"
          v-show="item.defaulted"
          :style="{ top: shared||isTemplate ? '-132px' : undefined }"
        >
          默认
        </div>
        <div class="point-name">{{ item.name }}</div>
      </div>
    </div>
    <Empty v-if="!pointList || pointList.length <= 0"></Empty>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { delViewPoint, delViewAnimation } from '@/api/viewer'
import _ from 'lodash'
import { PermissionLevel } from '@/configs/constants'
export default {
  name: 'ViewPointList',
  inject: ['shared'],
  props: {
    pointList: {
      type: Array,
      default: () => {
        return []
      }
    },
    viewType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      searchText: undefined,
      selectedPoint: undefined,
      seletcedItemId: undefined,
      isHaveNewPoint: false,
      createViewPointDebounce: () => {},
      createAnimationDebounce: () => {},
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['isTemplate', 'permissionLevel']),
    filtedPoints: function () {
      if (!this.searchText) {
        return this.pointList
      }
      const list = []
      for (let i = 0; i < this.pointList.length; i++) {
        if (this.pointList[i].name.indexOf(this.searchText) >= 0) {
          list.push(this.pointList[i])
        }
      }
      return list
    }
  },
  mounted () {
    this.createViewPointDebounce = _.debounce(this.createViewPoint.bind(this), 500)
    this.createAnimationDebounce = _.debounce(this.createAnimation.bind(this), 500)
  },
  methods: {
    onSelectPoint (item, index) {
      this.setSelectedIndex(index)
      if (this.viewType === 1) {
        this.$emit('showView', item)
      } else if (this.viewType === 2) {
        this.$emit('showAnimation', item)
      }
    },
    onResetPoint () {
      if (this.viewType === 1) {
        this.$emit('showView', this.pointList[this.selectedPoint])
      } else if (this.viewType === 2) {
        this.$emit('showAnimation', this.pointList[this.selectedPoint])
      }
    },
    onRemoveItem (data) {
      // if (data.defaulted) {
      //   this.$Message('warning', '默认视点不能删除')
      //   return
      // }
      this.$Delete({
        message: '您确定删除该数据吗，删除后不可恢复？',
        confirm: () => {
          if (!data || !data.id) {
            this.$emit('refresh')
            this.setSelectedIndex(undefined)
            this.$store.dispatch('showRight', false)
            return
          }
          this.removeItem([data.id])
        },
        cancel: () => {}
      })
    },
    // 删除视点
    removeItem (ids) {
      if (this.viewType === 1) {
        delViewPoint({
          ids: ids
        }).then((res) => {
          if (res.code === 200) {
            this.$emit('refresh')
            if (ids[0] === this.seletcedItemId) {
              this.setSelectedIndex(undefined)
              this.$store.dispatch('showRight', false)
            }
          }
        })
      } else if (this.viewType === 2) {
        delViewAnimation({
          ids: ids
        }).then((res) => {
          if (res.code === 200) {
            this.$emit('refresh')
            if (ids[0] === this.seletcedItemId) {
              this.setSelectedIndex(undefined)
              this.$store.dispatch('showRight', false)
            }
          }
        })
      }
    },
    // 播放动画
    playAnimation (data) {
      this.$emit('playViewAnimation', data)
    },
    searchPoint () {},
    createViewPoint () {
      if (this.permissionLevel <= PermissionLevel.LOOKER) {
        return
      }
      this.$emit('showView')
    },
    createAnimation () {
      if (this.permissionLevel <= PermissionLevel.LOOKER) {
        return
      }
      this.$emit('showAnimation')
    },
    onCreatePoint (point) {
      const data = JSON.parse(JSON.stringify(point))
      let index = 0
      if (this.isHaveNewPoint) {
        this.pointList.splice(0, 1, data)
      } else {
        // this.pointList.unshift(data)
        for (let i = 0; i < this.pointList.length; i++) {
          if (this.pointList[i].defaulted) {
            index = 1
            break
          }
        }

        this.pointList.splice(index, 0, data)
        this.setHaveNewPoint(true)
      }
      this.setSelectedIndex(index)
    },
    setHaveNewPoint (isNew) {
      this.isHaveNewPoint = isNew
    },
    setSelectedIndex (index) {
      this.selectedPoint = index
      if (this.selectedPoint !== undefined) {
        this.seletcedItemId = this.pointList[this.selectedPoint].id
      } else {
        this.seletcedItemId = undefined
      }
    },
    resetSetSelect () {
      for (let i = 0; i < this.pointList.length; i++) {
        if (this.pointList[i] === this.seletcedItemId) {
          this.setSelectedIndex(i)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.viewPointList {
  // text-align: left;
  font-size: 12px;
  overflow: hidden;
  .searchBox {
    width: calc(100% - 28px);
    // margin-bottom: 20px;
    height: 32px;
    display: flex;
    align-items: center;
    margin: 14px 0 14px 14px;
    .searchInput {
      width: 188px;
    }
    .add {
      width: 32px;
      height: 32px;
      margin-left: 8px;
      background: #00a4f0;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: white;
      &[disabled]{
        background:rgba(0, 164, 240, 0.6);
        cursor:not-allowed;
      }
    }
  }
  .point-list {
    height: calc(100% - 32px - 28px);
    padding: 0 14px;
    overflow: auto;
    .point-item {
      margin-bottom: 12px;
      .el-image {
        width: 228px;
        height: 128px;
        border-radius: 6px;
        .image-slot {
          text-align: center;
          vertical-align: middle;
          line-height: 128px;
        }
      }
      .point-name {
        color: #999;
        padding: 0 8px;
        text-align: left;
        @include show_ellipsis(1);
        // clear: both;
        // margin-top: -34px;
      }
      .top-tag {
        position: relative;
        top: -136px;
        right: 2px;
        display: inline-block;
        width: 34px;
        height: 20px;
        background: linear-gradient(-90deg, #008ed0, #8abeff);
        opacity: 0.8;
        border-radius: 0px 6px 0px 6px;
        text-align: center;
        clear: both;
        float: right;
      }
      .bottom-btns {
        position: relative;
        top: -29px;
        right: 0px;
        float: right;
        display: inline;
        align-items: center;
        height: 24px;
        background: #000000;
        opacity: 0.8;
        border-radius: 6px 0px 6px 0px;
        padding-left: 4px;
        margin-bottom: -20px;
        > .custom-icon {
          display: inline-block;
          margin-right: 3px;
          svg {
            font-size: 16px;
          }
          &:hover {
            > svg {
              color: $primary-color;
            }
          }
        }
      }
      &.active {
        .el-image {
          border: 2px solid #00a4f0;
        }
        .point-name {
          color: #fff;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.bottom-btns[shared]{
  display: none !important;
}
</style>
